/**
 * Internationalization (i18n) for Filmssavn Public Site
 * Supports Faroese (fo) and English (en)
 */

const translations = {
  fo: {
    // Navigation
    nav_home: 'Heim',
    nav_my_rentals: 'Mínar leigur',
    nav_documentary: 'Heimildarfilmar',
    nav_short_film: 'Stuttfilmar',
    nav_feature_film: 'Spælifilmar',
    nav_search: 'Leita',

    // Home Page
    home_hero_title: 'Úr Føroyum út í heim',
    home_hero_subtitle:
      'Stroyma er ein serstøk føroysk stroymingartænasta og eitt filmssavn við føroyskum filmum, sum kunnu røkkast um allan heim.',
    home_hero_cta: 'Byrja at hyggja',
    home_hero_learn: 'Les meira',

    // Categories (plural - for menus and section titles)
    category_documentary: 'Heimildarfilmar',
    category_short: 'Stuttfilmar',
    category_feature: 'Spælifilmar',
    category_documentary_desc: 'Veruligar søgur úr Føroyum',
    category_short_desc: 'Stuttar søgur við stórari ávirkan',
    category_feature_desc: 'Heilar filmupplivingar',

    // Categories (singular - for labeling individual films)
    category_singular_documentary: 'Heimildarfilmur',
    category_singular_documentary_short: 'Stuttur heimildarfilmur',
    category_singular_documentary_long: 'Longri heimildarfilmur',
    category_singular_short: 'Stuttfilmur',
    category_singular_feature: 'Spælifilmur',

    // Browse Page
    browse_title: 'Sí alt innihald',
    browse_subtitle: 'Kaga í okkara fulla savni av føroyskari søguforteljing',
    filter_all: 'Allir filmar',
    filter_recent: 'Nýtt',

    // Watch Page
    watch_logline: 'Stutt um filmin',
    watch_synopsis: 'Samandráttur',
    watch_cast: 'Høvuðsleikarar',
    watch_key_crew: 'Lyklapersónar á filmsliðnum',
    watch_director: 'Leikstjóri',
    watch_screenwriter: 'Handritshøvundur',
    watch_producer: 'Framleiðari',
    watch_cinematographer: 'Filmsfotografur',
    watch_editor: 'Klippari',
    watch_composer: 'Tónaskald',
    watch_production: 'Framleiðslufelag',
    // Key Crew Roles
    role_production_designer: 'Framleiðslusniðgevi',
    role_costume_designer: 'Búnasniðgevi',
    role_makeup_artist: 'Sminkulistafólk',
    role_sound_recordist: 'Ljóðmeistari',
    role_sound_designer: 'Ljóðsniðgevi',
    role_gaffer: 'Ljósmeistari',
    role_key_grip: 'Høvuðsgrippur',
    role_colourist: 'Litviðgeri',
    watch_language: 'Mál',
    watch_subtitles: 'Undirtekstir',
    watch_screenings: 'Sýningar & Virðislønir',
    watch_read_more_imdb: 'Les meira á IMDb',
    watch_back: 'Aftur',
    watch_login_required: 'Rita inn fyri at hyggja',
    watch_login_message: 'Tú mást rita inn fyri at síggja filmar á Stroyma.',
    watch_sign_in: 'Rita inn',
    watch_payment_sign_in_message: 'Rita inn fyri at kanna gjaldið fyri leiguna.',
    watch_payment_sign_in: 'Rita inn og kanna gjaldið',
    watch_payment_checking: 'Kanna gjaldið og atgongdina til filmin…',
    watch_payment_check_failed: 'Vit kundu ikki vátta gjaldið enn. Kanna støðuna aftur.',
    watch_payment_pending: 'Gjaldið verður viðgjørt. Kanna støðuna aftur, áðrenn tú roynir at gjalda umaftur.',
    watch_payment_check_again: 'Kanna gjaldið',
    watch_payment_resume: 'Halt fram við gjaldingini',
    watch_payment_unpaid: 'Gjaldið varð ikki gjøgnumført. Tú kanst royna at leiga aftur.',
    watch_payment_refunded: 'Gjaldið fyri hesa leiguna er afturgoldið.',
    watch_payment_expired: 'Leigutíðin er farin.',

    // My Rentals Page
    rentals_title: 'Mínar leigur',
    rentals_subtitle: 'Sí og umsit tínar leigaðu filmar',
    rentals_loading: 'Lesur tínar leigur...',
    rentals_none_title: 'Ongar Leigur enn',
    rentals_none_message: 'Tú hevur ikki leigað nakran film enn. Kaga í okkara úrval fyri at byrja!',
    rentals_browse: 'Kaga í filmum',
    rentals_active: 'Virknar leigur',
    rentals_expired: 'Útgingnar leigur',
    rentals_status_active: 'Virkin',
    rentals_status_expired: 'Útgingin',
    rentals_watch_now: 'Hygg nú',
    rentals_rent_again: 'Leiga aftur',
    rentals_expires_in: 'Gongur út um',
    rentals_expired_on: 'Útgingin',
    rentals_error_title: 'Kann ikki lesa leigur',
    rentals_error_message: 'Tað var ein feilur við at lesa tínar leigur. Vinarliga royn aftur seinni.',
    rentals_retry: 'Royn aftur',
    rentals_time_day: 'dagur',
    rentals_time_days: 'dagar',
    rentals_time_hour: 'tími',
    rentals_time_hours: 'tímar',
    rentals_time_minute: 'minuttur',
    rentals_time_minutes: 'minuttir',

    // Rental/Purchase
    rent_for: 'Leiga fyri',
    rent_currency: 'kr',
    hour_access: 'atgongd í {hours} tímar',
    access_expires: 'Atgongd gongur út',

    // Common
    no_videos: 'Eingir filmar enn.',
    watch_now: 'Hygg nú',

    // Footer
    footer_description:
      'Stroyma er ein serstøk føroysk stroymingartænasta og eitt filmssavn við føroyskum filmum, sum kunnu røkkast um allan heim. Tað er <a href="https://www.filmshusid.fo/" target="_blank" rel="noopener noreferrer" style="color: var(--color-nordic-blue); text-decoration: underline;">Filmshúsið</a>, sum eigur og umsitur Stroyma.',
    footer_address: 'Vestara Bryggja 15, 3. hædd, 100 Tórshavn, Føroyar',
    footer_phone: '+298 522233',
    footer_email: 'ffi@ffi.fo',
    footer_terms: 'Brúkaratreytir',
    footer_privacy: 'Dátuverndarpolitikkur',
    footer_about: 'Um okkum',
    footer_built_with: 'Bygt við',
    footer_copyright: `© ${new Date().getFullYear()} Stroyma. Øll rættindi tilskilað.`,
    footer_admin_login: 'Rita inn/Skráset brúkara',

    // Legal Pages
    legal_back_home: 'Heim',

    // Terms & Conditions
    terms_title: 'Brúkaratreytir',
    terms_intro:
      'Hesar treytir eru galdandi fyri Stroyma. Við at keypa atgongd til ein film, góðkennir tú hesar treytir:',
    terms_last_updated: `Seinast dagført: ${new Date().toLocaleDateString('fo-FO')}`,
    terms_section_1_title: '1. Persónlig nýtsla',
    terms_section_1_content:
      'Títt keyp gevur tær eitt persónligt, ikki-flytført loyvi at síggja filmin. Atgongdin er ætlað til privata nýtslu og má ikki nýtast til almenna sýning.',
    terms_section_2_title: '2. Avmarkingar fyri nýtslu',
    terms_section_2_content:
      'Tað er strangliga bannað at:<br>• Avrita, taka niður, upptaka ella gera eintøk av filminum á annan hátt.<br>• Víðarideila tína atgongd ella innritanarupplýsingar við onnur.<br>• Leiga út, selja ella víðarigeva filmin.<br>• Broyta, burturbeina ella oyða tøkniligar verndir (Digital rights management, DRM) á tænastuni.',
    terms_section_3_title: '3. Innihald',
    terms_section_3_content:
      'Alt innihald á tænastuni er ognað av teimum einstøku rættindahavarunum (framleiðarum) og er vart sambært galdandi Løgtingslóg um upphavsrætt. Filmshúsið er einans tøkniligur miðlari av innihaldinum.',
    terms_section_4_title: '4. Broytingar',
    terms_section_4_content: 'Vit loyva okkum rættin at broyta hesar treytir.',

    // Privacy Policy
    privacy_title: 'Dátuverndarpolitikkur',
    privacy_intro:
      'Vit virða títt privatlív. Hesin dátuverndarpolitikkur greiðir frá, hvussu vit savna og nýta tínar persónsupplýsingar.',
    privacy_last_updated: `Seinast dagført: ${new Date().toLocaleDateString('fo-FO')}`,
    privacy_section_1_title: '1. Hvat savna vit?',
    privacy_section_1_content:
      '• Upplýsingar, tú gevur okkum: Tína teldupostadressu og navn, tá tú stovnar ein brúkara.<br>• Keypsupplýsingar: Vit goyma ikki tínar gjaldskortsupplýsingar. Alt gjald fer fram trygt gjøgnum okkara gjaldsveitara (t.d. Stripe/Nets). Vit goyma einans skjalprógv fyri sjálvum keypinum.',
    privacy_section_2_title: '2. Hví savna vit tað?',
    privacy_section_2_content:
      '• At umsita tín brúkara og geva tær atgongd til keypt tilfar.<br>• At senda tær kvittanir og tænastuboð.<br>• At halda okkara løgfrøðiligu skyldur, eitt nú mvg-roknskap.',
    privacy_section_3_title: '3. Víðarigeving',
    privacy_section_3_content:
      'Vit selja ella víðarigeva ongantíð tínar persónsupplýsingar til triðja part til marknaðarføringarendamál. Vit deila einans upplýsingar við okkara tøkniligu veitarar (t.d. gjaldsveitara, servara-veitara) í tann mun, tað er neyðugt fyri at útvega tænastuna.',
    privacy_section_4_title: '4. Goymsla',
    privacy_section_4_content:
      'Vit goyma tínar upplýsingar so leingi, tú hevur ein virknan brúkara, og sum lógarkravt er (t.d. sambært roknskaparlóg).',
    privacy_section_5_title: '5. Tíni rættindi',
    privacy_section_5_content:
      'Tú hevur rætt at biðja um innlit í, rætta ella strika upplýsingar vit hava um teg. Set teg í samband við okkum á ffi@ffi.fo.',

    // About Stroyma
    about_title: 'Um okkum',
    about_section_1_title: 'Um Stroyma',
    about_section_1_content:
      '<p>Stroyma er ein serstøk stroymingartænasta og eitt filmssavn við føroyskum filmum, sum kunnu røkkast um allan heim.</p>',
    about_section_2_title: 'Okkara mál',
    about_section_2_content:
      '<p>Endamálið er at savna føroyskar filmar og røðir á einum stað. Við hesum tryggja vit, at:</p><ul><li>føroyingar fáa møguleikan at síggja føroyskar framleiðslur á føroyskum.</li><li>føroysk børn kunnu síggja føroyskt tilfar á føroyskum og úr føroyskum jørðildi.</li><li>føroyskar framleiðslur ikki hvørva, men verða varðveittar og tøkar nú og í framtíðini.</li><li>filmsfólk fáa ein pall at vísa og selja síni verk í Føroyum og uttanlands.</li><li>føroyskir filmar verða tøkir hjá øllum kring heimin á einfaldan hátt.</li><li>okkara felags mentanararvur verður varðveittur.</li></ul>',
    about_section_3_title: 'Okkara savn',
    about_section_3_content:
      '<p>Filmar, heimildarfilmar og røðir, sum kunnu liggja á Stroyma, eru almennir føroyskir filmar í góðari góðsku. Lýsingarfilmar, videoløg og privatir filmar verða ikki góðkendir.</p><p>Ábyrgdari og eigari av skipanini er Filmshúsið.</p>',
    about_section_4_title: 'Tøkni',
    about_section_4_content:
      '<p>Tú kanst síggja filmarnar á PC/MAC, teldli ella fartelefon og nýta allar vanligar kagar. Tað er neyðugt at hava netsamband, og góðskan kann ávirkast av ferðini á internetinum.</p>',

    // Search
    search_placeholder: 'Leita eftir filmum...',
    search_hint: 'Skriva heiti, navn á leikstjóra ella aðrar upplýsingar fyri at leita.',
    search_results: 'Úrslit',
    result: 'úrslit',
    results: 'úrslit',
    search_no_results: 'Ongin filmur funnin',

    // Geo-blocking
    watch_geo_blocked_title: 'Ikki tøkt',
    watch_geo_blocked_message: 'Hesin filmurin er ikki tøkur í tínum landi. Filmurin kann bert síggjast í Føroyum.',
  },

  en: {
    // Navigation
    nav_home: 'Home',
    nav_my_rentals: 'My Rentals',
    nav_documentary: 'Documentaries',
    nav_short_film: 'Short Films',
    nav_feature_film: 'Feature Films',
    nav_search: 'Search',

    // Home Page
    home_hero_title: 'Discover Faroese Originals.',
    home_hero_subtitle: 'From the cliffs to your screen — stories born in the North Atlantic.',
    home_hero_cta: 'Start Watching',
    home_hero_learn: 'Learn More',

    // Categories (plural - for menus and section titles)
    category_documentary: 'Documentaries',
    category_short: 'Short Films',
    category_feature: 'Feature Films',
    category_documentary_desc: 'Real stories from the Faroe Islands',
    category_short_desc: 'Concise storytelling at its finest',
    category_feature_desc: 'Full-length cinematic experiences',

    // Categories (singular - for labeling individual films)
    category_singular_documentary: 'Documentary',
    category_singular_documentary_short: 'Short Documentary',
    category_singular_documentary_long: 'Long Documentary',
    category_singular_short: 'Short Film',
    category_singular_feature: 'Feature Film',

    // Browse Page
    browse_title: 'Browse All Content',
    browse_subtitle: 'Explore our complete collection of Faroese storytelling',
    filter_all: 'All Films',
    filter_recent: 'Recent',

    // Watch Page
    watch_logline: 'Logline',
    watch_synopsis: 'Synopsis',
    watch_cast: 'Cast',
    watch_key_crew: 'Key Crew',
    watch_director: 'Director',
    watch_screenwriter: 'Screenwriter',
    watch_producer: 'Producer',
    watch_cinematographer: 'Cinematographer',
    watch_editor: 'Editor',
    watch_composer: 'Composer',
    watch_production: 'Production Company',
    // Key Crew Roles
    role_production_designer: 'Production Designer',
    role_costume_designer: 'Costume Designer',
    role_makeup_artist: 'Makeup Artist',
    role_sound_recordist: 'Sound Recordist',
    role_sound_designer: 'Sound Designer',
    role_gaffer: 'Gaffer',
    role_key_grip: 'Key Grip',
    role_colourist: 'Colourist',
    watch_language: 'Language',
    watch_subtitles: 'Subtitles',
    watch_screenings: 'Screenings & Awards',
    watch_read_more_imdb: 'Read more on IMDb',
    watch_back: 'Back',
    watch_login_required: 'Sign In Required',
    watch_login_message: 'You must be signed in to watch films on Stroyma',
    watch_sign_in: 'Sign In',
    watch_payment_sign_in_message: 'Sign in to confirm your rental payment.',
    watch_payment_sign_in: 'Sign in to check payment',
    watch_payment_checking: 'Confirming your payment and rental access…',
    watch_payment_check_failed: 'We could not confirm your payment yet. Check its status again.',
    watch_payment_pending: 'Your payment is being processed. Check its status before paying again.',
    watch_payment_check_again: 'Check payment status',
    watch_payment_resume: 'Resume payment',
    watch_payment_unpaid: 'The payment did not complete. You can try renting again.',
    watch_payment_refunded: 'This rental payment was refunded.',
    watch_payment_expired: 'This rental has expired.',

    // My Rentals Page
    rentals_title: 'My Rentals',
    rentals_subtitle: 'View and manage your rented videos',
    rentals_loading: 'Loading your rentals...',
    rentals_none_title: 'No Rentals Yet',
    rentals_none_message: "You haven't rented any videos yet. Browse our collection to get started!",
    rentals_browse: 'Browse Videos',
    rentals_active: 'Active Rentals',
    rentals_expired: 'Expired Rentals',
    rentals_status_active: 'Active',
    rentals_status_expired: 'Expired',
    rentals_watch_now: 'Watch Now',
    rentals_rent_again: 'Rent Again',
    rentals_expires_in: 'Expires in',
    rentals_expired_on: 'Expired on',
    rentals_error_title: 'Unable to Load Rentals',
    rentals_error_message: 'There was an error loading your rentals. Please try again later.',
    rentals_retry: 'Retry',
    rentals_time_day: 'day',
    rentals_time_days: 'days',
    rentals_time_hour: 'hour',
    rentals_time_hours: 'hours',
    rentals_time_minute: 'minute',
    rentals_time_minutes: 'minutes',

    // Rental/Purchase
    rent_for: 'Rent for',
    rent_currency: 'kr',
    hour_access: '{hours} hour access',
    access_expires: 'Access expires',

    // Common
    no_videos: 'No videos available yet.',
    watch_now: 'Watch Now',

    // Footer
    footer_description:
      'Stroyma is a unique Faroese streaming service and film archive with Faroese films that can be accessed worldwide. It is <a href="https://www.filmshusid.fo/" target="_blank" rel="noopener noreferrer" style="color: var(--color-nordic-blue); text-decoration: underline;">The Faroese Film Institute</a> that owns and operates Stroyma.',
    footer_address: 'Vestara Bryggja 15, 3rd Floor, 100 Tórshavn, Faroe Islands',
    footer_phone: '+298 522233',
    footer_email: 'ffi@ffi.fo',
    footer_terms: 'Terms of Use',
    footer_privacy: 'Privacy Policy',
    footer_about: 'About us',
    footer_built_with: 'Built with',
    footer_copyright: `© ${new Date().getFullYear()} Stroyma. All rights reserved.`,
    footer_admin_login: 'Sign In/Register',

    // Legal Pages
    legal_back_home: 'Home',

    // Terms & Conditions
    terms_title: 'Terms of Use',
    terms_intro: 'These terms apply to Stroyma. By purchasing access to a film, you accept these terms:',
    terms_last_updated: `Last updated: ${new Date().toLocaleDateString('en-US')}`,
    terms_section_1_title: '1. Personal Use',
    terms_section_1_content:
      'Your purchase gives you a personal, non-transferable license to view the film. Access is intended for private use and may not be used for public screening.',
    terms_section_2_title: '2. Restrictions on Use',
    terms_section_2_content:
      'It is strictly forbidden to:<br>• Copy, download, record, or otherwise make copies of the film.<br>• Further distribute your access or login information with others.<br>• Rent out, sell or pass on the film.<br>• Modify, bypass or remove technical protections (Digital rights management, DRM) on the service.',
    terms_section_3_title: '3. Content',
    terms_section_3_content:
      'All content on the service is owned by the individual rights holders (producers) and is protected according to the applicable Copyright Act. Filmshúsið acts solely as a technical intermediary for the content.',
    terms_section_4_title: '4. Changes',
    terms_section_4_content: 'We reserve the right to change these terms.',

    // Privacy Policy
    privacy_title: 'Privacy Policy',
    privacy_intro: 'We respect your privacy. This privacy policy explains how we collect and use your personal data.',
    privacy_last_updated: `Last updated: ${new Date().toLocaleDateString('en-US')}`,
    privacy_section_1_title: '1. What do we collect?',
    privacy_section_1_content:
      '• Information you provide us: Your email address and name when you create a user account.<br>• Purchase information: We do not store your payment card information. All payments are conducted securely through our payment provider (e.g. Stripe/Nets). We only store proof of the purchase itself.',
    privacy_section_2_title: '2. Why do we collect it?',
    privacy_section_2_content:
      '• To manage your user account and provide you with access to purchased content.<br>• To send you receipts and service messages.<br>• To fulfill our legal obligations, such as VAT accounting.',
    privacy_section_3_title: '3. Disclosure',
    privacy_section_3_content:
      'We never sell or disclose your personal data to third parties for marketing purposes. We only share information with our technical providers (e.g. payment provider, server provider) to the extent necessary to provide the service.',
    privacy_section_4_title: '4. Retention',
    privacy_section_4_content:
      'We store your information for as long as you have an active user account, and as required by law (e.g. according to the Accounting Act).',
    privacy_section_5_title: '5. Your rights',
    privacy_section_5_content:
      'You have the right to request access to, correction or deletion of information we have about you. Contact us at ffi@ffi.fo.',

    // About Stroyma
    about_title: 'About us',
    about_section_1_title: 'About Stroyma',
    about_section_1_content:
      '<p>Stroyma is a unique streaming service and film archive featuring Faroese films that can be accessed worldwide.</p>',
    about_section_2_title: 'Our Goal',
    about_section_2_content:
      '<p>The objective is to gather Faroese films and series in one place. By doing this, we ensure that:</p><ul><li>Faroese people have the opportunity to watch Faroese productions in Faroese.</li><li>Faroese children can watch Faroese content in Faroese and from a Faroese cultural context.</li><li>Faroese productions do not disappear, but are preserved and available now and in the future.</li><li>filmmakers are provided with a platform to showcase and sell their work in the Faroe Islands and abroad.</li><li>Faroese films are made easily accessible to everyone around the world.</li><li>our shared cultural heritage is preserved.</li></ul>',
    about_section_3_title: 'Our Collection',
    about_section_3_content:
      '<p>Films, documentaries, and series that can be hosted on Stroyma are official Faroese films of high quality. Commercials, music videos, and private films will not be approved.</p><p>The responsible entity and owner of the platform is Filmshúsið.</p>',
    about_section_4_title: 'Technology',
    about_section_4_content:
      '<p>You can watch the films on a PC/Mac, tablet, or mobile phone using any standard web browser. An internet connection is required, and the video quality may be affected by your internet speed.</p>',

    // Search
    search_placeholder: 'Search for films...',
    search_hint: 'Type titles, directors, or other information to search.',
    search_results: 'Search Results',
    result: 'result',
    results: 'results',
    search_no_results: 'No films found',

    // Geo-blocking
    watch_geo_blocked_title: 'Not Available',
    watch_geo_blocked_message:
      'This film is not available in your region. It can only be viewed from the Faroe Islands.',
  },
};

// Current language (defaults to Faroese)
let currentLanguage = localStorage.getItem('filmssavn_public_language') || 'fo';

/**
 * Get translation for a key
 */
export function t(key) {
  return translations[currentLanguage][key] || key;
}

/**
 * Set current language
 */
export function setLanguage(lang) {
  if (translations[lang]) {
    currentLanguage = lang;
    localStorage.setItem('filmssavn_public_language', lang);
    // Reload page to apply translations
    window.location.reload();
  }
}

/**
 * Get current language
 */
export function getLanguage() {
  return currentLanguage;
}

// Alias for consistency
export const getCurrentLanguage = getLanguage;

/**
 * Detect user location and set language automatically
 * Faroese if in Faroe Islands, English otherwise
 */
async function detectLanguageByLocation() {
  try {
    // Use free IP geolocation API
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.warn('Failed to detect location, defaulting to Faroese');
      return 'fo'; // Default to Faroese
    }

    const data = await response.json();
    const countryCode = data.country_code;

    // Faroe Islands country code is 'FO'
    if (countryCode === 'FO') {
      return 'fo';
    } else {
      return 'en';
    }
  } catch (error) {
    console.warn('Error detecting location:', error);
    return 'fo'; // Default to Faroese on error
  }
}

/**
 * Initialize i18n system
 * Automatically detects language based on location if no preference is saved
 */
export async function initI18n() {
  const savedLang = localStorage.getItem('filmssavn_public_language');

  if (savedLang && translations[savedLang]) {
    // User has manually selected a language, use it
    currentLanguage = savedLang;
  } else {
    // No saved preference, detect based on location
    const detectedLang = await detectLanguageByLocation();
    if (translations[detectedLang]) {
      currentLanguage = detectedLang;
      localStorage.setItem('filmssavn_public_language', detectedLang);
    }
  }
}

/**
 * Get category display name (bilingual format)
 */
export function getCategoryDisplay(category) {
  if (!category) return '';

  const categoryMap = {
    documentary: { fo: 'Heimildarfilmur', en: 'Documentary' },
    documentary_short: { fo: 'Stuttur heimildarfilmur', en: 'Short Documentary' },
    documentary_long: { fo: 'Longri heimildarfilmur', en: 'Long Documentary' },
    short: { fo: 'Stuttfilmur', en: 'Short Feature' },
    feature: { fo: 'Spælifilmur', en: 'Feature' },
  };

  const cat = categoryMap[category];
  if (!cat) return category;

  // Return bilingual format: "Føroyskt / English"
  return `${cat.fo} / ${cat.en}`;
}
